import { LiveStatsTopics, STATS_TYPES, AGGREGATION_LEVELS } from '@ahaslides-product/frontend-toolkit'

const pollActions = {
  subscribePollUpdateAction: async ({ dispatch }, { slide }) => {
    if (!slide || !slide.id) return
    if (slide.SlideOptions && slide.SlideOptions.length > 0) {
      dispatch('fetchStatsByWildCardAction', {
        path: `${STATS_TYPES.ANSWER_COUNT}/${AGGREGATION_LEVELS.PER_ANSWER_VALUE}/${slide.id}/${slide.version}`,
      })
      await dispatch('fetchStatsByKeyAction', {
        statsKeys: [
          LiveStatsTopics.answererCountPerQuestionTopic(
            slide.id,
            0, // the default value for questionId
            slide.version,
          ),
        ],
      })
    }

    dispatch('subscribeStatsAction', {
      identifier: slide.id,
      statsType: STATS_TYPES.ANSWER_COUNT,
      aggregationLevel: AGGREGATION_LEVELS.PER_ANSWER_VALUE,
    })

    dispatch('subscribeStatsAction', {
      identifier: slide.id,
      statsType: STATS_TYPES.ANSWERER_COUNT,
      aggregationLevel: AGGREGATION_LEVELS.PER_QUESTION,
    })
  },
}

export default pollActions
